import * as React from 'react'

import { Alert } from 'react-bootstrap'

const messages: any = {
	groupSignup: {
		success_en: {
			title: 'Your account has been created successfully!',
			text: 'You will be redirected shortly.',
			style: 'success',
		},
		username_en: {
			title: 'There was a problem creating your account!',
			text: 'Your username should be a valid email address.',
			style: 'danger',
		},
		firstname_en: {
			title: 'There was a problem creating your account!',
			text: 'First name is required.',
			style: 'danger',
		},
		companyName_en: {
			title: 'There was a problem creating your account!',
			text: 'Company name is required.',
			style: 'danger',
		},
		password_en: {
			title: 'There was a problem creating your account!',
			text: 'Password is required.',
			style: 'danger',
		},
		language_en: {
			title: 'There was a problem creating your account!',
			text: 'Language is required.',
			style: 'danger',
		},
		success_fi: {
			title: 'Kiitos rekisteröitymisestä ReadPeakiin!',
			text: 'Teidät ohjataan eteenpäin pian.',
			style: 'success',
		},
		username_fi: { title: 'Rekisteröityminen epäonnistui!', text: 'Tarkista sähköpostiosoite.', style: 'danger' },
		firstname_fi: { title: 'Rekisteröityminen epäonnistui!', text: 'Tarkista etunimi.', style: 'danger' },
		companyName_fi: { title: 'Rekisteröityminen epäonnistui!', text: 'Tarkista yrityksen nimi.', style: 'danger' },
		password_fi: { title: 'Rekisteröityminen epäonnistui!', text: 'Tarkista salasana.', style: 'danger' },
		language_fi: { title: 'Rekisteröityminen epäonnistui!', text: 'Tarkista kieli.', style: 'danger' },
	},
}

/**
 * function accept object as parameter
 * @params: { feature: 'groupSignup', message: 'username' } or { title: 'This email has already been taken!', text: 'Please correct the error and retry.', style: 'danger' }
 * return: Alert component with flash message
 *
 */

export default function flash(misc: { feature?: string; message?: string } = {}) {
	if (misc.hasOwnProperty('title')) {
		return displayFlash(misc)
	}
	if (misc.hasOwnProperty('feature') && misc.feature && misc.message) {
		return displayFlash(messages[misc.feature][misc.message])
	}
	return undefined
}

const displayFlash = (feature: any) => {
	return (
		<Alert bsStyle={feature.style}>
			<strong>
				{feature.title}
				<br /> {feature.text}{' '}
			</strong>
		</Alert>
	)
}
